import { ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from "@angular/core";

enum QuestionTypeEnum {
    INFO = 'INFO',
    ACTION = 'ACTION'
}

enum ValueTypeEnum {
    INPUT = 'INPUT',
    OPTION = 'OPTION'
}

interface WebinarQuestion {
    Section: number,
    SubSection: string,
    Question: string,
    Note?: string,
    Options?: string[],
    Visible: boolean,
    QuestionType: QuestionTypeEnum,
    ValueType?: ValueTypeEnum,
    Placeholder?: string,

    Image?: string,


    Questions?: WebinarQuestion[]
}


@Component({
    selector: 'feedback-webinar',
    templateUrl: "./feedback-webinar.component.html",
    styleUrls: ["./feedback-webinar.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class FeedbackWebinarComponent implements OnInit {
    ValueTypeEnum = ValueTypeEnum;
    QuestionTypeEnum = QuestionTypeEnum;
    jaNeinList: string[] = ["Ja", "Nein"];
    optionsList: string[] = ["Sehr", "Mäßig", "Neutral", "Wenig", "Uberhaupt nicht"];
    optionsList2: string[] = ["Viel", "Mäßig", "Neutral", "Wenig", "Keine"];
    optionsList3: string[] = ["Häufig", "Mäßig", "Neutral", "Wenig", "Keine"];
    questions: WebinarQuestion[] = [
        {
            Section: 1,
            SubSection: '',
            Question: 'Haben Sie Erfahrung mit der Verordnung von Cannabis?',
            Note: '',
            Options: this.optionsList2,
            QuestionType: QuestionTypeEnum.ACTION,
            ValueType: ValueTypeEnum.OPTION,
            Visible: true
        },
        {
            Section: 2,
            SubSection: '',
            Question: 'Hatten Sie bisher Probleme mit der Antragstellung (GKV)?',
            Note: '',
            Options: this.optionsList3,
            QuestionType: QuestionTypeEnum.ACTION,
            ValueType: ValueTypeEnum.OPTION,
            Visible: true
        },
        {
            Section: 3,
            SubSection: '',
            Question: 'Haben Sie das Copeia Webinar als informativ empfunden?',
            Note: '',
            Options: this.optionsList,
            QuestionType: QuestionTypeEnum.ACTION,
            ValueType: ValueTypeEnum.OPTION,
            Visible: true
        },
        {
            Section: 4,
            SubSection: '',
            Question: 'Dürfen wir Sie über weitere Entwicklungen und neue Funktionen des Antragstools informieren?',
            Note: '',
            Options: this.jaNeinList,
            QuestionType: QuestionTypeEnum.ACTION,
            ValueType: ValueTypeEnum.OPTION,
            Visible: true,
            Questions: [
                {
                    Section: 4,
                    SubSection: 'Email',
                    Question: 'Wenn Ja, bitte geben Sie ihre E-Mail an:',
                    Note: '',
                    Options: this.optionsList,
                    QuestionType: QuestionTypeEnum.ACTION,
                    ValueType: ValueTypeEnum.INPUT,
                    Placeholder: "E-Mail",
                    Visible: false
                }
            ]
        },
        {
            Section: 5,
            SubSection: '',
            Question: 'Uns ist sehr an ihrem Feedback gelegen um die Applikation weiterzuentwickeln und zu optimieren. Über das ? Symbol haben Sie die Möglichkeit uns Feedback zu den einzelnen Fragen zu geben:',
            QuestionType: QuestionTypeEnum.INFO,
            Visible: true,
            Image: '/images/medizinisches/Feedback_1.svg'
        }
    ]

    lastQuestionNo = this.questions[this.questions.length - 1].Section + 1;

    get jsPanelContentHeight() {
        if (document.getElementsByClassName("jsPanel-content").length) {
            return document.getElementsByClassName("jsPanel-content")[0].clientHeight;
        }
        else {
            return document.body.clientHeight;
        }
    }

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit(): void {
    }

    activeSelectedOption(quest: WebinarQuestion, item: string) {

    }

    selectOption(quest: WebinarQuestion, item: string) {
        quest.Note = item;
        if (quest.Section === 4 && quest.SubSection === '') {
            if (item === this.jaNeinList[0]) {
                quest.Questions.forEach(item => {
                    item.Visible = true;
                })
            } else {
                quest.Questions.forEach(item => {
                    item.Visible = false;
                })
            }
            this.cd.detectChanges();
        }
    }
}
